import React, { useState, useContext } from "react";
import { CartDispatchContext, addToCart } from "contexts/cart";
import {
  ProductsStateContext,
  ProductsDispatchContext,
  getProducts
} from "contexts/products";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Badge from "@material-ui/core/Badge";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
// import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { Grid, Input, Select } from 'react-spreadsheet-grid';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ToggleButton from 'react-bootstrap/ToggleButton';

const ProductCard = ({ data }) => {
  const [isAdded, setIsAdded] = useState(false);
  const [itemCount, setItemCount] = useState(1);
  const dispatch_cart = useContext(CartDispatchContext);
  const dispatch_product = useContext(ProductsDispatchContext);
  const [rowsdata, setRows] = useState(data);
  // console.log(data)
  // console.log(rowsdata)
  const onFieldChange = (rowId, field) => (value) => {
    // newrows = rows.map()
    // Find the row that is being changed
    // const row = rows.find( id =>  id['id'] === rowId );
    // console.log(row);
    // console.log(rows)
    // console.log(field)
    // console.log(rowId)
    // Change a value of a field
    const Intvalue = parseInt(value)
    // const rowId = 95
    if (!isNaN(Intvalue)){
      // console.log(data[parseInt(rowId)-1]['quantity'],'set2')
      // console.log('set',rowId,field,Intvalue)
      // console.log(rowsdata[parseInt(rowId)-1][field],'set3')
      rowsdata[parseInt(rowId)-1][field] = Intvalue;
      // console.log(rowsdata[parseInt(rowId)-1][field],'set4')
      setRows({...rowsdata})
      // console.log(rowsdata[parseInt(rowId)-1][field],'::::::::::set5::::::::>>');
      // console.log(data[parseInt(rowId)-1][field],'set6')
      getProducts(dispatch_product,rowsdata);
      // console.log(data[parseInt(rowId)-1][field],'set7')
      // console.log(rowsdata[parseInt(rowId)-1][field],'set8')

    }
    
    
}
  
  var id = 0
  var field = 'quantity'
  const incNum =()=>{
    // console.log(rowsdata[parseInt(id)-1],'i')
    const num  = rowsdata[parseInt(id)-1][field]
    if(num<100) 
    {
      rowsdata[parseInt(id)-1][field] = num + 1 ;
      setRows({...rowsdata})
    // console.log(rowsdata);
      getProducts(dispatch_product,rowsdata);
    }
  };
  const decNum = () => {
    const num  = rowsdata[parseInt(id)-1][field]
     if(num>0)
     {
      rowsdata[parseInt(id)-1][field] = rowsdata[parseInt(id)-1][field] - 1 ;
      setRows({...rowsdata})
    // console.log(rowsdata);
    getProducts(dispatch_product,rowsdata);
     }
  }
  const initColumns = () => {
    return [
        // {
        //   title:'Images',
        //   value: (row, { focus }) => {
        //       return <img src={row.icon}  alt="cracker"></img>;
        //   },
        //   id: 'Images',
        //   width: 10
        // },
        {
          title: 'Category',
          value: (row, { focus }) => {
              if (row.category.substr(row.category.length-1) === ':') {
                return  <div dangerouslySetInnerHTML={{ __html: "<span style='color:#faf9f9;'>"+row.category.slice(0, -1)+"</span>" }}/>}
              else {
                return row.category;
              }
          
          },id: 'Category',
          width:25
        },{
          title: 'Product',
          value: (row, { focus }) => {
              return row.product;

          },
          id: 'Product',
          width: 22
        },
        {
          title: 'Price',
          value: (row) => {
              return row.price.toFixed(1);
          },
          id: 'Price',
          width: 12
        }, {
          title: '50% off',
          value: (row, { focus }) => {
              return row.discountprice.toFixed(1);
          },
          id: '50% off',
          width: 12
        },{
          title: () => 'Quantity',
          value: (row,{focus}) => {
            // return row.quantity
              return (
                <Input
                    value={row.quantity}
                    onChange={onFieldChange(row.id, 'quantity')}
                    focus={focus}/>);
              
          },
          id: 'Quantity',
          width: 10
        }
        ,{
          title: 'Inc/Dec',
          value: (row ,{focus}) => {
             {id = row.id}
              return (
                <>
                  {/* <div className="col-xl-1">
                  <div class="input-group"> */}
                {/* <div class="input-group-prepend"> */}
                <Button
            variant="outline-danger"
            size="sm"
            onClick={decNum}
          >
            <strong>-</strong>
          </Button>
                  
                  <p> &ensp;</p>
                  {/* <button  onClick={incNum}><strong>-</strong></button> */}
                  <Button variant="outline-danger" size="sm" onClick={incNum}><strong>+</strong></Button>
                  
                {/* </div> */}
                {/* <Input
                    value={row.quantity}
                    onChange={onFieldChange(row.id, 'quantity')}
                  /> */}
                  {/* <Form.Control size="sm" type="text" value={row.quantity} onChange={onFieldChange(row.id, 'quantity')} /> */}
                {/* <input type="text" class="form-control" value={1}/> */}
                {/* <div class="input-group-prepend"> */}
                  
                {/* </div>
              </div>
              </div> */}
                </>
                  
              );
            
          },
        }
      ]
  }
  const [columns, setColumns] = useState(initColumns())

  const onColumnResize = (widthValues) => {
      const newColumns = [].concat(columns)
      Object.keys(widthValues).forEach((columnId) => {
          const column = columns.find(({ id }) => id === columnId);
          column.width = widthValues[columnId]
      })
      setColumns(newColumns)
  }


  return (
    <div style={{ width: "auto", overflow: "auto" }}>
    
    <div style={{ minWidth: "450px", maxHeight: "700px" }}>
    <Grid
      isScrollable
      focusOnSingleClick
      columns={columns}
          rows={data}
          getRowKey={row => row.id}
          rowHeight={60}
          disabledCellChecker={(row, columnId) => {
              return columnId === 'Price' ||
                  columnId === 'Category' ||
                  columnId === 'Images' || 
                  columnId === 'Product' ||
                  columnId === '50% off' ||
                  columnId === 'Inc/Dec';
                  // columnId === ' ';
          }}
          isColumnsResizable
          onColumnResize={onColumnResize}
    />
    

    </div></div> 
      );
};


export default ProductCard;
